webpackJsonp([0],{

/***/ "++x8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getdetail();
    }
  },
  mounted: function mounted() {
    this.getdetail();
  },
  methods: {
    getdetail: function getdetail() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_page', this.$qs.stringify({
        cid: 20
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.cate;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "+1ZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")])],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('div',{staticClass:"our_list clearfix"},[_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/our/aboutUs"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i1"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("关于帝景")]),_vm._v(" "),_c('p',[_vm._v("ABOUT US")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/our/core"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i2"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("核心价值")]),_vm._v(" "),_c('p',[_vm._v("CORE VALUE")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/our/news"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i3"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("新闻")]),_vm._v(" "),_c('p',[_vm._v("NEWS")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/our/cases/15"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i4"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("客户案例")]),_vm._v(" "),_c('p',[_vm._v("CUSTORME CASE")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/our/brand/11"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i5"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("品牌精选")]),_vm._v(" "),_c('p',[_vm._v("BRAND SELECTION")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/our/contact"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i6"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("CONTACT US")])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our_item wd"},[_c('div',{staticClass:"our_item_img"},[_c('img',{staticClass:"wd_icon",attrs:{"src":"/static/images/wd.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"wd_code",attrs:{"src":"/static/images/code.jpg","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our_item tmall"},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i8"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+7sO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+M8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m_product clearfix"},[_c('div',{staticClass:"product_head"},[_c('img',{staticClass:"p_back",attrs:{"src":"/static/images/m/back.png","alt":""},on:{"click":_vm.back}}),_vm._v(" "),_c('p',{staticClass:"p_head_name"},[_vm._v("产品分类")])]),_vm._v(" "),_c('div',{staticClass:"p_leftmenu_wrap"},[_c('div',{staticClass:"p_leftmenu"},[_vm._l((_vm.Category),function(item){return [_c('div',{class:{leftmenu_item:true,active:_vm.index==item.id},on:{"click":function($event){_vm.index=item.id}}},[_c('div',{staticClass:"menu_img"},[_c('img',{staticClass:"icon1",attrs:{"src":_vm.domain+item.icon1,"alt":""}}),_vm._v(" "),_c('img',{staticClass:"icon2",attrs:{"src":_vm.domain+item.icon2,"alt":""}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.name))])])]})],2)]),_vm._v(" "),(_vm.data.length>0)?_c('div',{staticClass:"product_list_wrap animated slideInRight"},[_c('img',{attrs:{"src":_vm.domain+_vm.cate.wap_litpic,"alt":""}}),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('div',{staticClass:"listt_item clearfix"},[_c('p',{staticClass:"p_title"},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")]),_vm._v(" "),_vm._l((item.child),function(child){return (!item.art)?_c('div',{staticClass:"p_item"},[_c('router-link',{attrs:{"to":"/m/product/list/"+child.id}},[_c('div',{staticClass:"p_item_img"},[_c('img',{attrs:{"src":_vm.domain+child.litpic,"alt":""}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(child.name))])])],1):_vm._e()}),_vm._v(" "),_vm._l((item.art),function(child){return (item.art)?_c('div',{staticClass:"p_item"},[_c('router-link',{attrs:{"to":"/m/product/detail/"+child.id}},[_c('div',{staticClass:"p_item_img"},[_c('img',{attrs:{"src":_vm.domain+child.litpic,"alt":""}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(child.title))])])],1):_vm._e()})],2)})],2):_vm._e(),_vm._v(" "),(_vm.list.length>0)?_c('div',{staticClass:"product_list_wrap animated slideInRight"},[_c('img',{attrs:{"src":_vm.domain+_vm.cate.litpic,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"listt_item clearfix"},[_c('p',{staticClass:"p_title"},[_vm._v("\n        "+_vm._s(_vm.cate.name)+"\n      ")]),_vm._v(" "),_vm._l((_vm.list),function(item){return _c('div',{staticClass:"p_item"},[_c('router-link',{attrs:{"to":"/m/product/detail/"+item.id}},[_c('div',{staticClass:"p_item_img"},[_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))])])],1)})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+j5C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/6GP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m head clearfix"},[_c('i',{staticClass:"icons logo"}),_vm._v(" "),_c('div',{staticClass:"search_wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],attrs:{"type":"text","name":"搜索产品"},domProps:{"value":(_vm.keyword)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"icons search",on:{"click":_vm.search}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/JQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0E5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m_index productlist"},[_c('div',{staticClass:"index_banner"},[_c('div',{staticClass:"m_index p"},[_c('div',{staticClass:"product_wrap clearfix"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"product_item"},[_c('router-link',{attrs:{"to":'/m/product/detail/'+item.id}},[(item.flag==1)?_c('img',{staticClass:"icons_new",attrs:{"src":"/static/images/m/new.png","alt":""}}):_vm._e(),_vm._v(" "),(item.flag==2)?_c('img',{staticClass:"icons_hot",attrs:{"src":"/static/images/m/hot.png","alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p_img_wrap"},[_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"p_name"},[_c('p',{staticClass:"p_name_c"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.model))])])])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0I7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 案例\n  ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"cases_title"},[_vm._v("客户案例")]),_vm._v(" "),_c('div',{staticClass:"cases_tabs"},[_c('div',{class:{cases_tab:true, active:_vm.index==15},on:{"click":function($event){_vm.index=15}}},[_vm._v("全部案例")]),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('div',{class:{cases_tab:true, active:_vm.index==item.id},on:{"click":function($event){_vm.index=item.id}}},[_vm._v(_vm._s(item.name))])})],2),_vm._v(" "),(_vm.list.length>0)?_c('div',{staticClass:"cases_items clearfix animated slideInRight"},[_vm._l((_vm.list),function(item,index){return [_c('div',{class:{case_item:true, big:index==0}},[_c('router-link',{attrs:{"to":"/our/cases/detail/"+item.id}},[_c('img',{attrs:{"src":_vm.domain+item.litpic}}),_vm._v(" "),_c('div',{staticClass:"case_name"},[_c('div',[_c('i',{staticClass:"search"}),_vm._v(" "),_c('p',{staticClass:"name"},[_vm._v(_vm._s(item.title))])])])])],1)]})],2):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0QWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our cases"},[_c('p',{staticClass:"our_common_title"},[_vm._v("客户案例")]),_vm._v(" "),_c('div',{staticClass:"cases_tabs clearfix"},[_c('div',{staticClass:"cases_tab_wrap"},[_c('div',{class:{cases_tab:true, active:_vm.index==15},on:{"click":function($event){_vm.index=15}}},[_vm._v("全部案例")])]),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('div',{staticClass:"cases_tab_wrap"},[_c('div',{class:{cases_tab:true, active:_vm.index==item.id},on:{"click":function($event){_vm.index=item.id}}},[_vm._v(_vm._s(item.name))])])})],2),_vm._v(" "),(_vm.list.length>0)?_c('div',{staticClass:"case_items clearfix animated slideInRight"},[_vm._l((_vm.list),function(item,index){return [_c('div',{class:{case_img:true,big:index==0,small:index>0}},[_c('router-link',{attrs:{"to":"/m/our/cases/detail/"+item.id}},[_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}})])],1)]})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0vAv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1CF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      name: '',
      mobile: '',
      email: '',
      content: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {},
  methods: {
    submit: function submit() {
      if (!this.name) {
        alertMessage('请填写姓名');
        return false;
      }
      if (!/^1[34578]\d{9}$/.test(this.mobile)) {
        alertMessage('请填写电话');
        return false;
      }
      if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(this.email)) {
        alertMessage('请填写邮箱');
        return false;
      }
      if (!this.content) {
        alertMessage('请填写留言');
        return false;
      }
      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=comment', this.$qs.stringify({
        username: this.name,
        tel: this.mobile,
        email: this.email,
        content: this.content
      })).then(function (response) {
        console.log(response);
        alertMessage(response.data.info);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "1Lhz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      Category: [],
      hots: [],
      domain: '',
      index: '',
      cate: '',
      data: [],
      id: '',
      list: []
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getCategory();
    },
    'index': function index() {
      this.data = [];
      this.list = [];
      sessionStorage.setItem('id', this.index);
      this.getCategory2();
    }
  },
  mounted: function mounted() {
    if (!sessionStorage.getItem('id')) {
      this.index = 1;
    } else {
      this.index = sessionStorage.getItem('id');
    }

    this.id = this.$route.params.id;
    this.domain = this._routerRoot.domain;
    this.getCategory();
  },
  methods: {
    back: function back() {
      window.history.back();
    },

    getCategory: function getCategory() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        limit: 10,
        cid: 19,
        status: 1
      })).then(function (response) {
        console.log(response);
        _this.Category = response.data.data;
        //this.index=this.Category[0].id
        _this.getCategory2();
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCategory2: function getCategory2() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid: this.index
      })).then(function (response) {
        console.log(response);
        _this2.cate = response.data.cate;
        _this2.data = response.data.data;
        console.log(_this2.data);
        if (_this2.data.length == 0) {
          _this2.getList();
        }
        /*this.Category=response.data.data
        this.cate = response.data.cate
        this.getparent(this.cate.id)*/
        //this.parent=this._routerRoot.parent;

        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getList: function getList() {
      var _this3 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_product_lists', this.$qs.stringify({
        cid: this.index,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this3.list = response.data.data;
        //this.cate = response.data.cate
        //this.getparent(this.cate.id)
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "1bXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      Category: [],
      cate: '',
      domain: '',
      parent: [],
      list: []
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getCategory();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getCategory();
  },
  methods: {
    getparent: function getparent(id) {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid: id
      })).then(function (response) {
        console.log(response);
        _this.parent = response.data.data;
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCategory: function getCategory() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this2.Category = response.data.data;
        _this2.cate = response.data.cate;
        _this2.getparent(_this2.cate.id);
        if (_this2.Category.length == 0) {
          _this2.getList();
        }
        //this.parent=this._routerRoot.parent;

        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getList: function getList() {
      var _this3 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_product_lists', this.$qs.stringify({
        cid: this.$route.params.id,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this3.list = response.data.data;
        //this.cate = response.data.cate
        //this.getparent(this.cate.id)
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "2Fm2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2LPQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Hk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: [],
      index: '',
      list: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.index = this.$route.params.id;
      this.list = [];
      this.getCategory();
      //this.getList()
    },
    'index': function index() {
      this.list = [];
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getCategory();
    //this.getList()
    this.index = this.$route.params.id;
  },
  methods: {
    getCategory: function getCategory() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid: 15
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
        _this.getList();
      }).catch(function (error) {
        console.log(error);
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_picture_lists', this.$qs.stringify({
        cid: this.index,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this2.list = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "49xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_our_vue__ = __webpack_require__("puUb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699fdef9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_our_vue__ = __webpack_require__("+1ZE");
function injectStyle (ssrContext) {
  __webpack_require__("cjQH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-699fdef9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_our_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699fdef9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_our_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4orF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  watch: {}

});

/***/ }),

/***/ "4u5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Swiper__ = __webpack_require__("9gd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_swiper_dist_css_swiper_min_css__ = __webpack_require__("mgS3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_swiper_dist_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_swiper_dist_css_swiper_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isX: false,
      domain: '',
      banners: [],
      Category: [],
      hots: [],
      active: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getbanner();
      this.getCategory();
      this.getHot();
      this.getPage();
    }
  },
  mounted: function mounted() {
    //console.log(this)
    this.domain = this._routerRoot.domain;
    this.getbanner();
    this.getCategory();
    this.getHot();
    this.getPage();
  },
  methods: {
    go_product: function go_product(id) {
      sessionStorage.setItem('id', id);
      this.$router.push('/m/product');
    },

    getbanner: function getbanner() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=ads', this.$qs.stringify({
        type: 2
      })).then(function (response) {
        console.log(response);
        _this.banners = response.data.data;
        _this.$nextTick(function () {
          var mySwiper = new __WEBPACK_IMPORTED_MODULE_0_Swiper___default.a('.swiper-container', {
            loop: true,
            autoplay: 3000,
            autoplayDisableOnInteraction: false,

            // 如果需要分页器
            pagination: '.swiper-pagination',
            paginationClickable: true

            // 如果需要前进后退按钮
            /*nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',*/

            // 如果需要滚动条
            /*scrollbar: '.swiper-scrollbar',*/
          });
        });
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCategory: function getCategory() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        limit: 8,
        cid: 19,
        status: 1
      })).then(function (response) {
        console.log(response);
        _this2.Category = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getHot: function getHot() {
      var _this3 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_hot', this.$qs.stringify({})).then(function (response) {
        console.log(response);
        _this3.hots = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getPage: function getPage() {
      var _this4 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_page', this.$qs.stringify({
        cid: 20
      })).then(function (response) {
        console.log(response);
        _this4.active = response.data.cate;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }

});

/***/ }),

/***/ "5LQc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6xDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置：\n    "),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("\n      首页\n    ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v("\n      > 我们\n    ")]),_vm._v(" "),_vm._l((_vm.parent),function(item,index){return [(index==0)?_c('router-link',{attrs:{"to":"/our/cases/15","tag":"span"}},[_vm._v("\n          > "+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==1)?_c('router-link',{attrs:{"to":"/our/cases/"+item.id,"tag":"span"}},[_vm._v("\n          > "+_vm._s(item.name)+"\n      ")]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('div',{staticClass:"cases_detail"},[_c('p',{staticClass:"detail_name"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('p',{staticClass:"detail_time"},[_vm._v("时间："+_vm._s(_vm._f("time")(_vm.data.updatetime)))]),_vm._v(" "),_c('div',{staticClass:"cases_detail_content"},_vm._l((_vm.data.pictureurls),function(item){return _c('img',{attrs:{"src":_vm.domain+item.url,"alt":""}})}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "72XE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7PMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("4u5V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf78215_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("YEiy");
function injectStyle (ssrContext) {
  __webpack_require__("cNoL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cf78215_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7biW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__("CNvo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d1fc71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__("HHb6");
function injectStyle (ssrContext) {
  __webpack_require__("MPZL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14d1fc71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d1fc71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8w7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leavemsg_vue__ = __webpack_require__("Ga8u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3014bc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leavemsg_vue__ = __webpack_require__("xott");
function injectStyle (ssrContext) {
  __webpack_require__("V8F7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3014bc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leavemsg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3014bc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leavemsg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "90+D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m foot clearfix"},[_c('div',{staticClass:"foot_list clearfix"},[_c('div',{staticClass:"foot_menu"},[_c('router-link',{attrs:{"to":"/m/index"}},[_c('i',{staticClass:"icons i1"}),_vm._v(" "),_c('p',[_vm._v("首 页")])])],1),_vm._v(" "),_c('div',{staticClass:"foot_menu"},[_c('div',{on:{"click":_vm.gop}},[_c('router-link',{attrs:{"to":"/m/product"}},[_c('i',{staticClass:"icons i2"}),_vm._v(" "),_c('p',[_vm._v("产 品")])])],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"foot_menu"},[_c('router-link',{attrs:{"to":"/m/leavemsg"}},[_c('i',{staticClass:"icons i4"}),_vm._v(" "),_c('p',[_vm._v("留 言")])])],1),_vm._v(" "),_c('div',{staticClass:"foot_menu"},[_c('router-link',{attrs:{"to":"/m/our"}},[_c('i',{staticClass:"icons i5"}),_vm._v(" "),_c('p',[_vm._v("我 们")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot_menu"},[_c('a',{attrs:{"href":"tel:021-52366166"}},[_c('i',{staticClass:"icons i3"}),_vm._v(" "),_c('p',[_vm._v("热 线")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Nx+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "9mDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our cases"},[_c('p',{staticClass:"our_common_title"},[_vm._v("品牌精选")]),_vm._v(" "),_c('div',{staticClass:"cases_tabs clearfix"},[_c('div',{staticClass:"cases_tab_wrap"},[_c('div',{class:{cases_tab:true, active:_vm.index==11},on:{"click":function($event){_vm.index=11}}},[_vm._v("全部品牌")])]),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('div',{staticClass:"cases_tab_wrap"},[_c('div',{class:{cases_tab:true, active:_vm.index==item.id},on:{"click":function($event){_vm.index=item.id}}},[_vm._v(_vm._s(item.name))])])})],2),_vm._v(" "),(_vm.list.length>0)?_c('div',{staticClass:"brand_items clearfix animated slideInRight"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"brand_item"},[_c('router-link',{attrs:{"to":"/m/our/brand/detail/"+item.id}},[_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.description))])])],1)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9pHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getdetail();
    }
  },
  mounted: function mounted() {
    this.getdetail();
  },
  methods: {
    getdetail: function getdetail() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=getdetail', this.$qs.stringify({
        id: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "AJHT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "APsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isX: false
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "Aubl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cate: '',
      list: []
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=search', this.$qs.stringify({
        keyword: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this.list = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "AvT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 留言\n  ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('div',{staticClass:"leavemsg_wrap"},[_c('p',{staticClass:"leavemsg_waring"},[_vm._v("* 请填写您的留言，收到留言后我们会及时与您沟通！")]),_vm._v(" "),_c('div',{staticClass:"leavemsg_form"},[_c('div',{staticClass:"input_form clearfix"},[_c('div',{staticClass:"form_item"},[_c('span',[_vm._v("姓名：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","name":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form_item"},[_c('span',[_vm._v("电话：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],attrs:{"type":"text","name":""},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form_item"},[_c('span',[_vm._v("邮箱：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","name":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"from_item_textarea"},[_c('span',[_vm._v("留言:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"submit",on:{"click":_vm.submit}},[_vm._v("提 交")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B4Mo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p_list"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置：\n    "),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("\n      首页\n    ")]),_vm._v(" "),_vm._l((_vm.parent),function(item,index){return [(index==0)?_c('router-link',{attrs:{"to":"/product","tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==1)?_c('router-link',{attrs:{"to":"/product/list/"+item.id,"tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==3)?_c('router-link',{attrs:{"to":"/product/list2/"+item.id,"tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e()]})],2),_vm._v(" "),(_vm.cate.litpic)?_c('img',{staticClass:"list_banner",attrs:{"src":_vm.domain+_vm.cate.litpic}}):_vm._e(),_vm._v(" "),_vm._l((_vm.Category),function(item){return _c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title sp"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"p_items clearfix"},[_vm._l((item.child),function(child){return (!item.art)?_c('div',{staticClass:"p_item"},[_c('router-link',{attrs:{"to":'/product/list2/'+child.id}},[_c('div',[_c('img',{attrs:{"src":_vm.domain+child.litpic}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(child.name))])])],1):_vm._e()}),_vm._v(" "),_vm._l((item.art),function(child){return (item.art)?_c('div',{staticClass:"p_item"},[_c('router-link',{attrs:{"to":'/product/detail/'+child.id}},[_c('div',[_c('img',{attrs:{"src":_vm.domain+child.litpic}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(child.title))])])],1):_vm._e()})],2)])}),_vm._v(" "),(_vm.list.length>0)?_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title sp"},[_vm._v(_vm._s(_vm.cate.name))]),_vm._v(" "),_c('div',{staticClass:"p_items clearfix"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"p_item"},[_c('router-link',{attrs:{"to":'/product/detail/'+item.id}},[_c('div',[_c('img',{attrs:{"src":_vm.domain+item.litpic}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.title))])])],1)}))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BBN/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BbgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap container"},[_c('router-view',{attrs:{"name":"head"}}),_vm._v(" "),_c('router-view',{staticClass:"animated slideInRight"}),_vm._v(" "),_c('div',{staticClass:"fixed_right"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"fixed_item",on:{"click":_vm.gotop}},[_c('img',{staticClass:"fimg",attrs:{"src":"/static/images/arrow_t.png","alt":""}})])]),_vm._v(" "),_c('router-view',{attrs:{"name":"foot"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed_item"},[_c('img',{staticClass:"fimg",attrs:{"src":"/static/images/qq.png","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed_item wechatcode"},[_c('img',{staticClass:"fimg",attrs:{"src":"/static/images/wechat.png","alt":""}}),_vm._v(" "),_c('img',{staticClass:"wxcode",attrs:{"src":"/static/images/code.jpg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Btyl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Busw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m_index productlist",style:({minHeight:_vm.minh})},[_c('div',{staticClass:"index_banner"},[_c('div',{staticClass:"product_head"},[_c('img',{staticClass:"p_back",attrs:{"src":"/static/images/m/back.png","alt":""},on:{"click":_vm.back}}),_vm._v(" "),_c('p',{staticClass:"p_head_name"},[_vm._v(_vm._s(_vm.cate.name))])]),_vm._v(" "),_c('div',{staticClass:"m_index p"},[_c('div',{staticClass:"product_wrap clearfix"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"product_item"},[_c('router-link',{attrs:{"to":'/m/product/detail/'+item.id}},[(item.flag==1)?_c('img',{staticClass:"icons_new",attrs:{"src":"/static/images/m/new.png","alt":""}}):_vm._e(),_vm._v(" "),(item.flag==2)?_c('img',{staticClass:"icons_hot",attrs:{"src":"/static/images/m/hot.png","alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p_img_wrap"},[_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"p_name"},[_c('p',{staticClass:"p_name_c"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.model))])])])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CNvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      Category: [],
      hots: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
      this.getHot();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getHot();
  },
  methods: {
    getHot: function getHot() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=search', this.$qs.stringify({
        keyword: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this.hots = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "Cz1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getdetail();
    }
  },
  mounted: function mounted() {
    this.getdetail();
  },
  methods: {
    getdetail: function getdetail() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_page', this.$qs.stringify({
        cid: 20
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.cate;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "DBBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our aboutUs"},[_c('img',{staticClass:"banner",attrs:{"src":"/static/images/m/contact.jpg","alt":""}}),_vm._v(" "),_c('p',{staticClass:"our_common_title"},[_vm._v("联系我们")]),_vm._v(" "),_c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_c('div',{staticClass:"aboutUs_item_text"},[_c('p',[_vm._v("上海帝景卫浴设备有限公司")]),_vm._v(" "),_c('p',[_vm._v("地址( ADD )：上海市徐汇区桂箐路7号G7-B201")]),_vm._v(" "),_c('p',[_vm._v("电话( TEL )：021-52366166 52366178")]),_vm._v(" "),_c('p',[_vm._v("网址：http://dking.vapps.me/dist/index.html")]),_vm._v(" "),_c('p',[_vm._v("电子邮件( E-MAIL )："),_c('a',{attrs:{"href":"mailto:wellness@dkingsh.com"}},[_vm._v("wellness@dkingsh.com")])]),_vm._v(" "),_c('p',[_vm._v("微信公众号：dkingsh")]),_vm._v(" "),_c('img',{staticClass:"contact_code",attrs:{"src":"/static/images/m/contact_code.png","alt":""}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DNGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__("Aubl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2322a842_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__("0E5D");
function injectStyle (ssrContext) {
  __webpack_require__("Vlrm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2322a842"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2322a842_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dh0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" > "+_vm._s(_vm.data.name)+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('div',{staticClass:"cases_detail"},[_c('p',{staticClass:"detail_name"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('div',{staticClass:"cases_detail_content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EJSk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aboutus.dde8be1.jpg";

/***/ }),

/***/ "EVG0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ErSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product_detail"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置：\n    "),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("\n      首页\n    ")]),_vm._v(" "),_vm._l((_vm.parent),function(item,index){return [(index==0)?_c('router-link',{attrs:{"to":"/product","tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==1)?_c('router-link',{attrs:{"to":"/product/list/"+item.id,"tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==3)?_c('router-link',{attrs:{"to":"/product/list2/"+item.id,"tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"detail_top clearfix"},[_c('div',{staticClass:"detail_top_left"},[(_vm.data.pictureurls)?_c('img',{attrs:{"src":_vm.domain+_vm.data.pictureurls}}):_vm._e(),_vm._v(" "),(!_vm.data.pictureurls)?_c('img',{attrs:{"src":_vm.domain+_vm.data.litpic}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"detail_top_right"},[_c('p',{staticClass:"p_name"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"p_options"},[_c('div',{staticClass:"p_option clearfix"},[_c('div',{staticClass:"p_item"},[_vm._v("所属品类："+_vm._s(_vm.cate.name))]),_vm._v(" "),_c('div',{staticClass:"p_item"},[_vm._v("品牌："+_vm._s(_vm.data.brand))])]),_vm._v(" "),_c('div',{staticClass:"p_option clearfix"},[_c('div',{staticClass:"p_item"},[_vm._v("系列："+_vm._s(_vm.data.series))]),_vm._v(" "),_c('div',{staticClass:"p_item"},[_vm._v("型号："+_vm._s(_vm.data.model))])]),_vm._v(" "),_c('div',{staticClass:"p_option clearfix"},[_c('div',{staticClass:"p_item"},[_vm._v("规格："+_vm._s(_vm.data.specification))]),_vm._v(" "),_c('div',{staticClass:"p_item"},[_vm._v("颜色："+_vm._s(_vm.data.color))])]),_vm._v(" "),_c('div',{staticClass:"p_option clearfix"},[_c('div',{staticClass:"p_item"},[_vm._v("材质："+_vm._s(_vm.data.material))]),_vm._v(" "),_c('div',{staticClass:"p_item"},[_vm._v("使用人数："+_vm._s(_vm.data.nums))])]),_vm._v(" "),_c('div',{staticClass:"p_option clearfix"},[_c('div',{staticClass:"p_item"},[_vm._v("设计师："+_vm._s(_vm.data.designer))]),_vm._v(" "),_c('div',{staticClass:"p_item"},[_vm._v("产地："+_vm._s(_vm.data.area))])]),_vm._v(" "),_c('div',{staticClass:"p_option clearfix"},[_c('div',{staticClass:"p_item"},[_vm._v("货期："+_vm._s(_vm.data.updatetime))]),_vm._v(" "),_c('div',{staticClass:"p_item"},[_vm._v("安装方式："+_vm._s(_vm.data.installation))])])])])]),_vm._v(" "),_c('div',{staticClass:"detail_content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"p_content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_top"},[_c('div',{staticClass:"content_title"},[_vm._v("产品详情")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FSY8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/news.3167c11.jpg";

/***/ }),

/***/ "Famp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      news: [],
      limit: 10,
      showmore: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getList();
    /*  var that = this
      $('#news').scroll(function(){
      　　var scrollTop = $(this).scrollTop();
      　　var scrollHeight = $(document).height();
      　　var windowHeight = $(this).height();
      　　if(scrollTop + windowHeight == scrollHeight){
            that.more()
      　　}
      });*/
  },
  methods: {
    getList: function getList(type) {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_lists', this.$qs.stringify({
        cid: 18,
        page: 1,
        limit: this.limit
      })).then(function (response) {
        console.log(response);
        _this.news = response.data.data;
        if (_this.news.length < _this.limit && type == 1) {
          _this.showmore = false;
          alertMessage('列表已全部加载完');
        }
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    more: function more() {
      this.limit += 10;
      this.getList(1);
    }
  }

});

/***/ }),

/***/ "GGah":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_detail_vue__ = __webpack_require__("W9Xc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf134f08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_detail_vue__ = __webpack_require__("pyH+");
function injectStyle (ssrContext) {
  __webpack_require__("2Fm2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf134f08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf134f08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GPRb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ga8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      name: '',
      mobile: '',
      email: '',
      content: '',
      show: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {},
  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.name) {
        alertMessage('请填写姓名');
        return false;
      }
      if (!/^1[34578]\d{9}$/.test(this.mobile)) {
        alertMessage('请填写电话');
        return false;
      }
      if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(this.email)) {
        alertMessage('请填写邮箱');
        return false;
      }
      if (!this.content) {
        alertMessage('请填写留言');
        return false;
      }
      this.show = false;
      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=comment', this.$qs.stringify({
        username: this.name,
        tel: this.mobile,
        email: this.email,
        content: this.content
      })).then(function (response) {
        console.log(response);
        alertMessage(response.data.info);
        _this.show = true;
      }).catch(function (error) {
        console.log(error);
        _this.show = true;
      });
    }
  }
});

/***/ }),

/***/ "GjZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap container"},[_c('router-view',{attrs:{"name":"head"}}),_vm._v(" "),_c('router-view',{staticClass:"animated slideInRight"}),_vm._v(" "),_c('router-view',{attrs:{"name":"foot"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GrOO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/customer_s.45cecbb.jpg";

/***/ }),

/***/ "H5ru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our clearfix"},[_c('div',{staticClass:"our_list clearfix"},[_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/m/our/aboutUs"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i1"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("关于帝景")]),_vm._v(" "),_c('p',[_vm._v("ABOUT US")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/m/our/core"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i2"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("核心价值")]),_vm._v(" "),_c('p',[_vm._v("CORE VALUE")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/m/our/news"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i3"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("新闻")]),_vm._v(" "),_c('p',[_vm._v("NEWS")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/m/our/cases/15"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i4"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("客户案例")]),_vm._v(" "),_c('p',[_vm._v("CUSTORME CASE")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/m/our/brand/11"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i5"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("品牌精选")]),_vm._v(" "),_c('p',[_vm._v("BRAND SELECTION")])])],1),_vm._v(" "),_c('div',{staticClass:"our_item"},[_c('router-link',{attrs:{"to":"/m/our/contact"}},[_c('div',{staticClass:"our_item_img"},[_c('i',{staticClass:"icons i6"})]),_vm._v(" "),_c('p',{staticClass:"our_text"},[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("CONTACT US")])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our_item sp"},[_c('i',{staticClass:"icons i7"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our_item sp"},[_c('i',{staticClass:"icons i8"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HHb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"hot_wrap"},[_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title"},[_vm._v("搜索结果")]),_vm._v(" "),_c('div',{staticClass:"hotlist clearfix"},[_vm._l((_vm.hots),function(item){return _c('div',{staticClass:"hot_item"},[_c('router-link',{attrs:{"to":"/product/detail/"+item.id}},[_c('div',{staticClass:"hotimg_wrap"},[(item.flag==1)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("c1mo")}}):_vm._e(),_vm._v(" "),(item.flag==2)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("9Nx+")}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"p",attrs:{"src":_vm.domain+item.litpic}})]),_vm._v(" "),_c('p',{staticClass:"p_name"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"p_name_e"},[_vm._v(_vm._s(item.model))])])],1)}),_vm._v(" "),(!_vm.hots)?_c('p',{staticClass:"no_p"},[_vm._v("暂无产品")]):_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HIfF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hk+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our detail"},[_c('p',{staticClass:"our_common_title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('p',{staticClass:"detail_time"},[_vm._v(_vm._s(_vm._f("time")(_vm.data.updatetime)))]),_vm._v(" "),_c('div',{staticClass:"detail_content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HwNh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IQlt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ijw8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getdetail();
    }
  },
  mounted: function mounted() {
    this.getdetail();
  },
  methods: {
    getdetail: function getdetail() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=getdetail', this.$qs.stringify({
        id: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "Ikjb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isX: false
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "J1CV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cremq: false,
      cpcs: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "J8eG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_vue__ = __webpack_require__("jQr6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53534cc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_vue__ = __webpack_require__("9mDj");
function injectStyle (ssrContext) {
  __webpack_require__("qAoT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53534cc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53534cc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JEo2":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpDMjNCNDVFQUQ3NjYxMUU3OTA5MzhBRTVCMEFCMDVCNSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpDMjNCNDVFQkQ3NjYxMUU3OTA5MzhBRTVCMEFCMDVCNSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkMyM0I0NUU4RDc2NjExRTc5MDkzOEFFNUIwQUIwNUI1IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkMyM0I0NUU5RDc2NjExRTc5MDkzOEFFNUIwQUIwNUI1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+iDBMfgAAAdpJREFUeNqclUsoRFEYx+cKRVhIFkSU5FVMyUIW5JVHnguFbCgbSYqFpbKwQJLII6WkbKxIiIUoyUwSIUqKIoWaEHn8v/qfOl3uMPerX/e85jfncc93DZfL5bCIKlABkkEMeAJnQH6wAE5lkNPp/PFD/19k1aCPMj2iQQr/rBdMg3bwbBYYpplOghatPgt2OaswkA0KQAb7r0ARZntqJR0HrSwvgk5wabE1DWACBAMPiIf4XnX68VmqCYdBjRehxBxI59JDwJLeqaQzfG6BDsf/4hzUspzldrvLdalUIllvdPgWK2CD5W5dWsPyDjfe1xjgMwezDVHSWDYuOeyFOmlDtkFJw9l4Z1Mqh/XBcoSSetgQalMaqB24R0lv2JBrU5rIpUvsK+kqG0pAkA2per+PcQFulXQefIIAMOKjMB40sTyqv1IvoIv1ZlDvg3RZO+Qx840aBNvaFez+QyYZbA8ksZ6GpX+ZpRJ5HCjRDw5AGzNSHEhgjpiS/QOZHFsmZ4EXP98q9ZmzlbeQ21cJjsAb2zox4yHDIvPLzagDxSBVa38E62CTufddlg4OtTE9hpfPiYooJmgRXINXvVM+J1i6JO613/bUKuRynIALs1ATy+wLwYN8Jb4FGAC81HQs9AUtvAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "JXvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_us_vue__ = __webpack_require__("APsa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a50221_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_us_vue__ = __webpack_require__("R1aB");
function injectStyle (ssrContext) {
  __webpack_require__("Btyl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27a50221"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_us_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a50221_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_us_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jvgh":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3NzM2Qzg4RkQ3NjIxMUU3OEM4NUUxN0M3MEFFM0YxNSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3NzM2Qzg5MEQ3NjIxMUU3OEM4NUUxN0M3MEFFM0YxNSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc3MzZDODhERDc2MjExRTc4Qzg1RTE3QzcwQUUzRjE1IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjc3MzZDODhFRDc2MjExRTc4Qzg1RTE3QzcwQUUzRjE1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+MkSSHgAAALBJREFUeNrs2rEKgzAQxvEziHQ1z1Lfxo5d3ZR26Fyor+Dm4/Rd0tGOXmi7OYhQyMn/4Mvk8CNcOCHJjpepEJFeU2u8pF0vzahpc10emkZsVPm1Tk6Xk9irszPQHkvlnRgt4MCBAwduG56v/fB5P/wdU13f7Pim3aDHgQMHzgBiADGAOJzAgQNnADGA6HHgwIEDB74LeDDoDhE+GoQP8V+l02TyuRovEwf/HiHcZgEGAKB0HGpHp3yHAAAAAElFTkSuQmCC"

/***/ }),

/***/ "KNGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title"},[_vm._v("热门品类")]),_vm._v(" "),_c('div',{staticClass:"index_items clearfix"},_vm._l((_vm.Category),function(item){return _c('div',{staticClass:"index_item"},[_c('router-link',{attrs:{"to":"/product/list/"+item.id}},[_c('div',[(item.icon1)?_c('img',{attrs:{"src":_vm.domain+item.icon1}}):_vm._e()]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.name))])])],1)}))]),_vm._v(" "),_c('div',{staticClass:"hot_wrap"},[_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title"},[_vm._v("热门单品")]),_vm._v(" "),_c('div',{staticClass:"hotlist clearfix"},_vm._l((_vm.hots),function(item){return _c('div',{staticClass:"hot_item"},[_c('router-link',{attrs:{"to":"/product/detail/"+item.id}},[_c('div',{staticClass:"hotimg_wrap"},[(item.flag==1)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("c1mo")}}):_vm._e(),_vm._v(" "),(item.flag==2)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("9Nx+")}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"p",attrs:{"src":_vm.domain+item.litpic}})]),_vm._v(" "),_c('p',{staticClass:"p_name"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"p_name_e"},[_vm._v(_vm._s(item.model))])])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KZnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_vue__ = __webpack_require__("Famp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ebc4204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_vue__ = __webpack_require__("rJ9C");
function injectStyle (ssrContext) {
  __webpack_require__("+j5C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ebc4204"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ebc4204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KkIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 新闻\n  ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('img',{staticClass:"top_banner",attrs:{"src":__webpack_require__("FSY8")}}),_vm._v(" "),_c('div',{staticClass:"news_lists clearfix"},_vm._l((_vm.news),function(item){return _c('div',{staticClass:"news_item clearfix"},[_c('router-link',{attrs:{"to":"/our/news/detail/"+item.id}},[_c('img',{attrs:{"src":_vm.domain+item.litpic}}),_vm._v(" "),_c('div',{staticClass:"news_text"},[_c('div',{staticClass:"text_top"},[_c('p',{staticClass:"news_name"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"news_time"},[_vm._v(_vm._s(_vm._f("time")(item.updatetime)))])]),_vm._v(" "),_c('div',{staticClass:"news_desc"},[_vm._v(_vm._s(item.description))])])])],1)})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showmore),expression:"showmore"}],staticClass:"more",on:{"click":_vm.more}},[_vm._v("\n        加载更多\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LHFl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      news: [],
      limit: 10,
      showmore: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getList();
  },
  methods: {
    getList: function getList(type) {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_lists', this.$qs.stringify({
        cid: 18,
        page: 1,
        limit: this.limit
      })).then(function (response) {
        console.log(response);
        _this.news = response.data.data;
        if (_this.news.length < _this.limit && type == 1) {
          _this.showmore = false;
          alertMessage('列表已全部加载完');
        }
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    more: function more() {
      this.limit += 10;
      this.getList(1);
    }
  }

});

/***/ }),

/***/ "LsMg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact.f4d7fb7.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4897c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("WXmN");
function injectStyle (ssrContext) {
  __webpack_require__("Tjlm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4897c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAND":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MMer":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n      您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 核心价值\n    ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('img',{staticClass:"top_banner",attrs:{"src":__webpack_require__("WCc8")}}),_vm._v(" "),_c('div',{staticClass:"about_lists"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"about_item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"about_text"},[_c('p',{staticClass:"core_link"},[_vm._v("BISAZZA："),_c('router-link',{attrs:{"to":"/our/customer_s/1"}},[_vm._v("点击打开质保说明>>")])],1),_vm._v(" "),_c('p',{staticClass:"core_link"},[_vm._v("卫浴："),_c('router-link',{attrs:{"to":"/our/customer_s/2"}},[_vm._v("点击打开质保说明>>")])],1),_vm._v(" "),_c('p',{staticClass:"core_link"},[_vm._v("户外SPA："),_c('router-link',{attrs:{"to":"/our/customer_s/3"}},[_vm._v("点击打开质保说明>>")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("1")]),_vm._v(" "),_c('span',[_vm._v("帝景价值")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("1、为私人豪宅、五星级酒店及高级会所项目提供一站式健康卫浴系统解决方案;"),_c('br'),_vm._v("\n2、12 年高端卫浴服务，专注、专业、全心全力;"),_c('br'),_vm._v("\n3、品牌授权一级代理，一线品牌，合理价格;"),_c('br'),_vm._v("\n4、专业流程跟踪服务，安装售后，全程无忧;"),_c('br'),_vm._v("\n5、帝景•构建幸福健康生活!Dking wellness")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("2")]),_vm._v(" "),_c('span',[_vm._v("服务流程")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_c('img',{attrs:{"src":__webpack_require__("iqsr")}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("3")]),_vm._v(" "),_c('span',[_vm._v("售后保障")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MPZL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MWaZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our aboutUs"},[_c('p',{staticClass:"our_common_title"},[_vm._v("核心价值")]),_vm._v(" "),_c('img',{staticClass:"banner",attrs:{"src":"/static/images/m/core.jpg","alt":""}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"aboutUs_item_text"},[_c('p',{staticClass:"service"},[_vm._v("BISAZZA："),_c('router-link',{attrs:{"to":"/m/our/customer_s/1"}},[_vm._v("点击打开质保说明>>")])],1),_vm._v(" "),_c('p',{staticClass:"service"},[_vm._v("卫浴："),_c('router-link',{attrs:{"to":"/m/our/customer_s/2"}},[_vm._v("点击打开质保说明>>")])],1),_vm._v(" "),_c('p',{staticClass:"service"},[_vm._v("户外SPA："),_c('router-link',{attrs:{"to":"/m/our/customer_s/3"}},[_vm._v("点击打开质保说明>>")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_c('p',{staticClass:"item_tittle"},[_c('span',{staticClass:"num"},[_vm._v("1")]),_c('span',[_vm._v("帝景价值")])]),_vm._v(" "),_c('div',{staticClass:"aboutUs_item_text"},[_c('div',{staticClass:"core_item"},[_vm._v("\n           1、为私人豪宅、五星级酒店及高级会所项目提供一站式健康卫浴系统解决方案;\n         ")]),_vm._v(" "),_c('div',{staticClass:"core_item"},[_vm._v("\n           2、12 年高端卫浴服务，专注、专业、全心全力;\n         ")]),_vm._v(" "),_c('div',{staticClass:"core_item"},[_vm._v("\n           3、品牌授权一级代理，一线品牌，合理价格;\n         ")]),_vm._v(" "),_c('div',{staticClass:"core_item"},[_vm._v("\n           4、专业流程跟踪服务，安装售后，全程无忧;\n         ")]),_vm._v(" "),_c('div',{staticClass:"core_item"},[_vm._v("\n           5、帝景•构建幸福健康生活!Dking wellness\n         ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_c('p',{staticClass:"item_tittle"},[_c('span',{staticClass:"num"},[_vm._v("2")]),_c('span',[_vm._v("服务流程")])]),_vm._v(" "),_c('div',{staticClass:"aboutUs_item_text"},[_c('img',{staticClass:"core2",attrs:{"src":"/static/images/m/core2.png","alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"item_tittle"},[_c('span',{staticClass:"num"},[_vm._v("3")]),_c('span',[_vm._v("售后保障")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MiD0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Swiper__ = __webpack_require__("9gd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_swiper_dist_css_swiper_min_css__ = __webpack_require__("mgS3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_swiper_dist_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_swiper_dist_css_swiper_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isX: false,
      domain: '',
      banners: [],
      Category: [],
      hots: [],
      active: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
      this.getbanner();
      this.getCategory();
      this.getHot();
      this.getPage();
    }
  },
  mounted: function mounted() {
    //console.log(this)
    this.domain = this._routerRoot.domain;
    this.getbanner();
    this.getCategory();
    this.getHot();
    this.getPage();
  },
  methods: {
    getbanner: function getbanner() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=ads', this.$qs.stringify({
        type: 1
      })).then(function (response) {
        console.log(response);
        _this.banners = response.data.data;
        _this.$nextTick(function () {
          var mySwiper = new __WEBPACK_IMPORTED_MODULE_0_Swiper___default.a('.swiper-container', {
            loop: true,
            autoplay: 3000,
            autoplayDisableOnInteraction: false,

            // 如果需要分页器
            /* pagination: '.swiper-pagination',*/
            paginationClickable: true,

            // 如果需要前进后退按钮
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev'

            // 如果需要滚动条
            /*scrollbar: '.swiper-scrollbar',*/
          });
        });
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCategory: function getCategory() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        limit: 10,
        cid: 19,
        status: 1
      })).then(function (response) {
        console.log(response);
        _this2.Category = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getHot: function getHot() {
      var _this3 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_hot', this.$qs.stringify({})).then(function (response) {
        console.log(response);
        _this3.hots = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getPage: function getPage() {
      var _this4 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_page', this.$qs.stringify({
        cid: 20
      })).then(function (response) {
        console.log(response);
        _this4.active = response.data.cate;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }

});

/***/ }),

/***/ "MsoH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_detail_vue__ = __webpack_require__("jmor");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd296f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_detail_vue__ = __webpack_require__("ErSo");
function injectStyle (ssrContext) {
  __webpack_require__("MAND")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cd296f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd296f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+bi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_vue__ = __webpack_require__("jY4B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c4079b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_vue__ = __webpack_require__("TyV+");
function injectStyle (ssrContext) {
  __webpack_require__("0vAv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55c4079b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c4079b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N6DM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cate: '',
      list: [],
      minh: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getList();
    this.minh = document.documentElement.clientHeight - 100 + 'px';
  },
  methods: {
    back: function back() {
      window.history.back();
    },

    getList: function getList() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_product_lists', this.$qs.stringify({
        cid: this.$route.params.ids,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this.list = response.data.data;
        _this.cate = response.data.cate;
        //this.getparent(this.cate.id)
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "NFbN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our detail"},[_c('p',{staticClass:"our_common_title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('p',{staticClass:"detail_time"},[_vm._v(_vm._s(_vm._f("time")(_vm.data.updatetime)))]),_vm._v(" "),_c('div',{staticClass:"detail_content"},_vm._l((_vm.data.pictureurls),function(item){return _c('img',{attrs:{"src":_vm.domain+item.url,"alt":""}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$qs = __WEBPACK_IMPORTED_MODULE_6_qs___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.host = 'http://www.dking.store';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
/* eslint-disable no-new */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('time', function (input) {
  var d = new Date(input * 1000);
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  if (month < 10) {
    month = '0' + month;
  }
  var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
  var hour = d.getHours();
  var minutes = d.getMinutes();
  var seconds = d.getSeconds();
  return year + '-' + month + '-' + day;
});
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: function data() {
    return {
      domain: 'http://dking.vapps.me/',
      parent: []
    };
  },

  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  methods: {
    getconfig: function getconfig(title, desc) {
      var _this = this;

      this.$http.get('http://eydt.vapps.me/index.php?g=Index&m=Index&a=getconfig&ref=' + encodeURIComponent(window.location.href.split('#')[0])).then(function (response) {
        console.log(response);
        //console.log(this.jssdk)
        _this.jssdk = response.body.apilist;
        __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default.a.config({
          debug: false,
          appId: _this.jssdk.appid, // 和获取Ticke的必须一样------必填，公众号的唯一标识
          timestamp: _this.jssdk.timestamp, // 必填，生成签名的时间戳
          nonceStr: _this.jssdk.noncestr, // 必填，生成签名的随机串
          signature: _this.jssdk.str, // 必填，签名，见附录1
          //需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
        });
      });
      var that = this;
      var title = title;
      if (!desc) {
        desc = 'AI、智能制造、RPA、区块链纷至沓来。安永打造“数字科技”平台，助你鏖战数字化世界。';
      }
      /*      var desc = desc*/
      /*alert(window.location.href)*/
      __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default.a.ready(function () {
        __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default.a.onMenuShareTimeline({
          title: title, // 分享标题
          desc: desc, // 分享描述
          imgUrl: 'http://eydt.vapps.me/static/images/wx.jpg', // 分享图标
          link: window.location.href
        });

        __WEBPACK_IMPORTED_MODULE_5_weixin_js_sdk___default.a.onMenuShareAppMessage({
          title: title, // 分享标题
          desc: desc, // 分享描述
          imgUrl: 'http://eydt.vapps.me/static/images/wx.jpg', // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          link: window.location.href
        });
      });
    }
  }
});

/***/ }),

/***/ "NuG6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact_tmall.297cb1d.png";

/***/ }),

/***/ "O44t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("rL5W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e39fafa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("DBBZ");
function injectStyle (ssrContext) {
  __webpack_require__("UYez")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e39fafa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e39fafa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OUWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cpxq: true,
      cpcs: false,
      data: '',
      cate: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getDetail();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getDetail();
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_product_detail', this.$qs.stringify({
        id: this.$route.params.ids
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.data;
        _this.cate = response.data.cate;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "ObRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p_detail"},[(_vm.data.pictureurls)?_c('img',{staticClass:"p_detail_banner",attrs:{"src":_vm.domain+_vm.data.pictureurls}}):_vm._e(),_vm._v(" "),(!_vm.data.pictureurls)?_c('img',{staticClass:"p_detail_banner",attrs:{"src":_vm.domain+_vm.data.litpic}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"p_detail_name"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"p_detail_tabs clearfix"},[_c('div',{class:{p_detail_tab:true,active:_vm.cpxq},on:{"click":function($event){_vm.cpxq=true;_vm.cpcs=false}}},[_vm._v("\n     产品详情\n   ")]),_vm._v(" "),_c('div',{class:{p_detail_tab:true,active:_vm.cpcs},on:{"click":function($event){_vm.cpxq=false;_vm.cpcs=true}}},[_vm._v("\n     产品参数\n   ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.cpcs),expression:"!cpcs"}],staticClass:"cpxq_wrap m animated slideInRight",domProps:{"innerHTML":_vm._s(_vm.data.content)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cpcs),expression:"cpcs"}],staticClass:"cpcs_wrap animated slideInRight"},[_c('div',{staticClass:"cpcs_list clearfix"},[_c('div',{staticClass:"cpcs_item"},[_vm._v("所属品类："+_vm._s(_vm.cate.name))]),_vm._v(" "),_c('div',{staticClass:"cpcs_item"},[_vm._v("品牌："+_vm._s(_vm.data.brand))])]),_vm._v(" "),_c('div',{staticClass:"cpcs_list clearfix"},[_c('div',{staticClass:"cpcs_item"},[_vm._v("系列："+_vm._s(_vm.data.series))]),_vm._v(" "),_c('div',{staticClass:"cpcs_item"},[_vm._v("型号："+_vm._s(_vm.data.model))])]),_vm._v(" "),_c('div',{staticClass:"cpcs_list clearfix"},[_c('div',{staticClass:"cpcs_item"},[_vm._v("规格："+_vm._s(_vm.data.specification))]),_vm._v(" "),_c('div',{staticClass:"cpcs_item"},[_vm._v("颜色："+_vm._s(_vm.data.color))])]),_vm._v(" "),_c('div',{staticClass:"cpcs_list clearfix"},[_c('div',{staticClass:"cpcs_item"},[_vm._v("材质："+_vm._s(_vm.data.material))]),_vm._v(" "),_c('div',{staticClass:"cpcs_item"},[_vm._v("使用人数："+_vm._s(_vm.data.nums))])]),_vm._v(" "),_c('div',{staticClass:"cpcs_list clearfix"},[_c('div',{staticClass:"cpcs_item"},[_vm._v("设计师："+_vm._s(_vm.data.designer))]),_vm._v(" "),_c('div',{staticClass:"cpcs_item"},[_vm._v("产地："+_vm._s(_vm.data.area))])]),_vm._v(" "),_c('div',{staticClass:"cpcs_list clearfix"},[_c('div',{staticClass:"cpcs_item"},[_vm._v("货期："+_vm._s(_vm.data.updatetime))])]),_vm._v(" "),_c('div',{staticClass:"cpcs_list clearfix"},[_c('div',{staticClass:"cpcs_item"},[_vm._v("安装方式："+_vm._s(_vm.data.installation))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ourg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_detail_vue__ = __webpack_require__("Ijw8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec98eee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_detail_vue__ = __webpack_require__("aan0");
function injectStyle (ssrContext) {
  __webpack_require__("r83p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ec98eee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec98eee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P13t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PTzo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_detail_vue__ = __webpack_require__("vBKd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10250519_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_detail_vue__ = __webpack_require__("NFbN");
function injectStyle (ssrContext) {
  __webpack_require__("BBN/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10250519"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10250519_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pqnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_our_vue__ = __webpack_require__("wf20");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67194905_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_our_vue__ = __webpack_require__("H5ru");
function injectStyle (ssrContext) {
  __webpack_require__("P13t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67194905"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_our_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67194905_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_our_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QBCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_s_vue__ = __webpack_require__("zTpi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d26ebea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_s_vue__ = __webpack_require__("jFTN");
function injectStyle (ssrContext) {
  __webpack_require__("vfux")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d26ebea2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_s_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d26ebea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_s_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R1aB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 公司简介\n  ")],1),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_wrap"},[_c('img',{staticClass:"top_banner",attrs:{"src":__webpack_require__("EJSk")}}),_vm._v(" "),_c('div',{staticClass:"about_lists"},[_c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("1")]),_vm._v(" "),_c('span',[_vm._v("帝景")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球典范品质的纯进口卫浴产品及一站式系统服务。")])]),_vm._v(" "),_c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("2")]),_vm._v(" "),_c('span',[_vm._v("品牌")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("公司成立至今，已先后获得多个国际品牌的认可，目前代理品牌主要有意大利BISAZZA艺术马赛克、地板、卫浴，意大利FIR艺术水龙头、意大利WEBERT时尚水龙头，意大利DEVON&DEVON古典卫浴，德国HOESCH豪华按摩浴缸，美国CALDERA户外SPA等。")])]),_vm._v(" "),_c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("3")]),_vm._v(" "),_c('span',[_vm._v("理念")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("我们不仅提供原装进口的卫浴建材产品，更以为客户创造健康、舒适、高品质的卫浴生活方式为我们的价值理念，公司已先后服务于众多私人豪宅客户和酒店会所项目，获得优良口碑。从过去、现在到未来，公司一直专注于卫浴这一领域，立志成为中国领衔的卫浴服务商，为更多中国用户创造健康卫浴生活！")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RA+l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("bBBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f31d08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("Xg37");
function injectStyle (ssrContext) {
  __webpack_require__("puWL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71f31d08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f31d08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SCaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置：\n    "),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("\n      首页\n    ")]),_vm._v(" "),_vm._l((_vm.parent),function(item,index){return [(index==0)?_c('router-link',{attrs:{"to":"/product","tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==1)?_c('router-link',{attrs:{"to":"/product/list/"+item.id,"tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==3)?_c('router-link',{attrs:{"to":"/product/list2/"+item.id,"tag":"span"}},[_vm._v("\n         >"+_vm._s(item.name)+"\n      ")]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"hot_wrap"},[_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title"},[_vm._v(_vm._s(_vm.cate.name))]),_vm._v(" "),_c('div',{staticClass:"hotlist clearfix"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"hot_item"},[_c('router-link',{attrs:{"to":"/product/detail/"+item.id}},[_c('div',{staticClass:"hotimg_wrap"},[(item.flag==1)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("c1mo")}}):_vm._e(),_vm._v(" "),(item.flag==2)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("9Nx+")}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"p",attrs:{"src":_vm.domain+item.litpic}})]),_vm._v(" "),_c('p',{staticClass:"p_name"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"p_name_e"},[_vm._v(_vm._s(item.model))])])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TMLv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: [],
      index: '',
      list: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.index = this.$route.params.id;
      this.getCategory();
      //this.getList()
    },
    'index': function index() {
      this.list = [];
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getCategory();
    //this.getList()
    this.index = this.$route.params.id;
  },
  methods: {
    getCategory: function getCategory() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid: 15
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
        _this.getList();
      }).catch(function (error) {
        console.log(error);
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_picture_lists', this.$qs.stringify({
        cid: this.index,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this2.list = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "TPYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cremq: false,
      cpcs: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "TRvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our aboutUs"},[_c('p',{staticClass:"our_common_title"},[_vm._v("公司简介")]),_vm._v(" "),_c('img',{staticClass:"banner",attrs:{"src":"/static/images/m/aboutUs.jpg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_c('p',{staticClass:"item_tittle"},[_c('span',{staticClass:"num"},[_vm._v("1")]),_c('span',[_vm._v("帝景")])]),_vm._v(" "),_c('div',{staticClass:"aboutUs_item_text"},[_vm._v("\n         上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球典范品质的纯进口卫浴产品及一站式系统服务。\n       ")])]),_vm._v(" "),_c('div',{staticClass:"aboutUs_item"},[_c('p',{staticClass:"item_tittle"},[_c('span',{staticClass:"num"},[_vm._v("2")]),_c('span',[_vm._v("品牌")])]),_vm._v(" "),_c('div',{staticClass:"aboutUs_item_text"},[_vm._v("\n        公司成立至今，已先后获得多个国际品牌的认可，目前代理品牌主要有意大利BISAZZA艺术马赛克、地板、卫浴，意大利FIR艺术水龙头、意大利WEBERT时尚水龙头，意大利DEVON&DEVON古典卫浴，德国HOESCH豪华按摩浴缸，美国CALDERA户外SPA等。\n       ")])]),_vm._v(" "),_c('div',{staticClass:"aboutUs_item"},[_c('p',{staticClass:"item_tittle"},[_c('span',{staticClass:"num"},[_vm._v("3")]),_c('span',[_vm._v("理念")])]),_vm._v(" "),_c('div',{staticClass:"aboutUs_item_text"},[_vm._v("\n        我们不仅提供原装进口的卫浴建材产品，更以为客户创造健康、舒适、高品质的卫浴生活方式为我们的价值理念，公司已先后服务于众多私人豪宅客户和酒店会所项目，获得优良口碑。从过去、现在到未来，公司一直专注于卫浴这一领域，立志成为中国领衔的卫浴服务商，为更多中国用户创造健康卫浴生活！\n       ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tjlm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TqGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  watch: {}

});

/***/ }),

/***/ "TyV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 品牌精选\n  ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"cases_title"},[_vm._v("品牌精选")]),_vm._v(" "),_c('div',{staticClass:"cases_tabs"},[_c('div',{class:{cases_tab:true, active:_vm.index==11},on:{"click":function($event){_vm.index=11}}},[_vm._v("所有品牌")]),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('div',{class:{cases_tab:true, active:_vm.index==item.id},on:{"click":function($event){_vm.index=item.id}}},[_vm._v(_vm._s(item.name))])})],2),_vm._v(" "),(_vm.list.length>0)?_c('div',{staticClass:"brand_items clearfix animated slideInRight"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"brand_item clearfix"},[_c('img',{attrs:{"src":_vm.domain+item.litpic}}),_vm._v(" "),_c('div',{staticClass:"brand_text"},[_c('p',{staticClass:"brand_name"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"brand_desc"},[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/our/brand/detail/"+item.id}},[_c('div',{staticClass:"brand_btn"},[_vm._v("了解详情+")])])],1)])})):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UYez":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V1+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_core_vue__ = __webpack_require__("J1CV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aec5d44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_core_vue__ = __webpack_require__("MWaZ");
function injectStyle (ssrContext) {
  __webpack_require__("72XE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8aec5d44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_core_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8aec5d44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_core_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V8F7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VduZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_active_detail_vue__ = __webpack_require__("Cz1k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17c7f18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_active_detail_vue__ = __webpack_require__("Dh0E");
function injectStyle (ssrContext) {
  __webpack_require__("rSLk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a17c7f18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_active_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17c7f18_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_active_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vlrm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VvyA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W9Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: '',
      parent: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getpic();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getpic();
  },
  methods: {
    getparent: function getparent(id) {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid: id
      })).then(function (response) {
        console.log(response);
        _this.parent = response.data.data;
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getpic: function getpic() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=getdetail', this.$qs.stringify({
        id: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this2.data = response.data.data;
        _this2.getparent(_this2.data.cid);
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "WCc8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core.4841145.jpg";

/***/ }),

/***/ "WOdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cremq: false,
      cpcs: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "WXmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ismobile:_vm.ismobile},attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xg37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 联系我们\n  ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('img',{staticClass:"top_banner",attrs:{"src":__webpack_require__("LsMg")}}),_vm._v(" "),_c('div',{staticClass:"about_lists clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"contact_code"},[_c('img',{attrs:{"src":__webpack_require__("chP5")}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("NuG6")}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/leavemsg"}},[_c('div',{staticClass:"leave_msg"},[_vm._v("给我们留言")])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about_item contact"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num address"}),_vm._v(" "),_c('span',[_vm._v("帝景价值")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("\n          上海帝景卫浴设备有限公司"),_c('br'),_vm._v("\n          地址( ADD )：上海市徐汇区桂箐路7号G7-B201"),_c('br'),_vm._v("\n          电话( TEL )：021-52366166 52366178"),_c('br'),_vm._v("\n          网址：http://dking.vapps.me/dist/index.html"),_c('br'),_vm._v("\n          电子邮件( E-MAIL )："),_c('a',{attrs:{"href":"mailto:wellness@dkingsh.com"}},[_vm._v("wellness@dkingsh.com")]),_c('br'),_vm._v("\n          微信公众号：dkingsh"),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xsix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YEiy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m_index"},[_c('div',{staticClass:"index_banner"},[_c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.banners),function(item){return _c('div',{staticClass:"swiper-slide"},[(item.link)?_c('a',{attrs:{"href":item.link}},[(item.litpic)?_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),(!item.link)?_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}}):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"swiper-pagination"})]),_vm._v(" "),_c('div',{staticClass:"m_index"},[_c('p',{staticClass:"m_common_title"},[_vm._v("热门分类")]),_vm._v(" "),_c('div',{staticClass:"itemList clearfix"},[_vm._l((_vm.Category),function(item){return [_c('div',{staticClass:"item",on:{"click":function($event){_vm.go_product(item.id)}}},[_c('div',{staticClass:"item_img"},[(item.icon1)?_c('img',{attrs:{"src":_vm.domain+item.icon1}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"item_name"},[_vm._v(_vm._s(item.name))])])]})],2),_vm._v(" "),_c('router-link',{attrs:{"to":"/m/product"}},[_c('div',{staticClass:"morebtn"},[_vm._v("更多")])])],1),_vm._v(" "),_c('div',{staticClass:"m_index"},[_c('p',{staticClass:"m_common_title"},[_vm._v("精品活动")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/m/active/detail"}},[(_vm.active.icon2)?_c('img',{staticClass:"active_banner",attrs:{"src":_vm.domain+_vm.active.icon2}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"m_index p"},[_c('p',{staticClass:"m_common_title"},[_vm._v("热门单品")]),_vm._v(" "),_c('div',{staticClass:"product_wrap clearfix"},_vm._l((_vm.hots),function(item){return _c('div',{staticClass:"product_item"},[_c('router-link',{attrs:{"to":"/m/product/detail/"+item.id}},[(item.flag==1)?_c('img',{staticClass:"icons_new",attrs:{"src":"/static/images/m/new.png"}}):_vm._e(),_vm._v(" "),(item.flag==2)?_c('img',{staticClass:"icons_hot",attrs:{"src":"/static/images/m/hot.png"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p_img_wrap"},[_c('img',{attrs:{"src":_vm.domain+item.litpic}})]),_vm._v(" "),_c('div',{staticClass:"p_name"},[_c('p',{staticClass:"p_name_c"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.model))])])])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_foot__ = __webpack_require__("rQpX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_head__ = __webpack_require__("c6RT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_public_main__ = __webpack_require__("t17Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__("dAjm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product__ = __webpack_require__("u+Fy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_product_list__ = __webpack_require__("d1cz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_product_list2__ = __webpack_require__("oZAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_product_detail__ = __webpack_require__("MsoH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_our__ = __webpack_require__("49xc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_about_us__ = __webpack_require__("JXvx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_core__ = __webpack_require__("tDWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_news__ = __webpack_require__("cBVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_news_detail__ = __webpack_require__("Ourg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_cases__ = __webpack_require__("mTJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_cases_detail__ = __webpack_require__("m/Uf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_brand__ = __webpack_require__("N+bi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_brand_detail__ = __webpack_require__("GGah");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_contact__ = __webpack_require__("S4JM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_leavemsg__ = __webpack_require__("prnt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_customer_s__ = __webpack_require__("ewo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_search__ = __webpack_require__("7biW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_active_detail__ = __webpack_require__("VduZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__ = __webpack_require__("ZqLb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__ = __webpack_require__("d23r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_mobile_public_main__ = __webpack_require__("rjyW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_mobile_public_p_main__ = __webpack_require__("k6hN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_mobile_index__ = __webpack_require__("7PMi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_mobile_product__ = __webpack_require__("zuYS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_mobile_product_list__ = __webpack_require__("sV8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_mobile_product_detail__ = __webpack_require__("hZ2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_mobile_our__ = __webpack_require__("Pqnd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_mobile_about_us__ = __webpack_require__("oOp+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_mobile_core__ = __webpack_require__("V1+A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_mobile_news__ = __webpack_require__("KZnR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_mobile_news_detail__ = __webpack_require__("ihCQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_mobile_detail__ = __webpack_require__("qWnR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_mobile_cases__ = __webpack_require__("gCfj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_mobile_cases_detail__ = __webpack_require__("PTzo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_mobile_brand__ = __webpack_require__("J8eG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_mobile_contact__ = __webpack_require__("O44t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_mobile_customer_s__ = __webpack_require__("QBCv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_mobile_leavemsg__ = __webpack_require__("8w7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_mobile_search__ = __webpack_require__("DNGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_mobile_active_detail__ = __webpack_require__("zRjg");
















































/*import list from '@/components/list'*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/m',
    name: 'mindex',
    component: __WEBPACK_IMPORTED_MODULE_27__components_mobile_public_p_main__["a" /* default */],
    children: [{
      path: '',
      name: 'm_index',
      redirect: function redirect(to) {
        // 方法接收 目标路由 作为参数
        // return 重定向的 字符串路径/路径对象
        return '/index';
      },
      components: {
        default: __WEBPACK_IMPORTED_MODULE_28__components_mobile_index__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'product',
      name: 'm_product',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_29__components_mobile_product__["a" /* default */],
        /*head:m_head,*/
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }]
  }, {
    path: '/m',
    name: 'mindex',
    component: __WEBPACK_IMPORTED_MODULE_26__components_mobile_public_main__["a" /* default */],
    children: [{
      path: '',
      name: 'm_index',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_28__components_mobile_index__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'index',
      name: 'm_index',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_28__components_mobile_index__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'product/list/:ids',
      name: 'm_product_list',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_30__components_mobile_product_list__["a" /* default */],
        /*head:m_head,*/
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'product/detail/:ids',
      name: 'm_product_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_31__components_mobile_product_detail__["a" /* default */],
        /*head:m_head,*/
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our',
      name: 'm_our',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_32__components_mobile_our__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/aboutUs',
      name: 'm_our',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_33__components_mobile_about_us__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/core',
      name: 'm_core',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_34__components_mobile_core__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/news',
      name: 'm_news',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_35__components_mobile_news__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/news/detail/:id',
      name: 'm_news_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_36__components_mobile_news_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/cases/:id',
      name: 'm_cases',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_38__components_mobile_cases__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/cases/detail/:id',
      name: 'm_cases_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_39__components_mobile_cases_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/brand/:id',
      name: 'm_brand',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_40__components_mobile_brand__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/brand/detail/:id',
      name: 'm_brand',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_36__components_mobile_news_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/contact',
      name: 'm_brand',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_41__components_mobile_contact__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/customer_s/:id',
      name: 'customer_s',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_42__components_mobile_customer_s__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'leavemsg',
      name: 'm_leavemsg',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_43__components_mobile_leavemsg__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'search/:id',
      name: 'm_search',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_44__components_mobile_search__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }, {
      path: 'active/detail',
      name: 'm_active_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_45__components_mobile_active_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_25__components_mobile_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_24__components_mobile_public_foot__["a" /* default */]
      }
    }]
  }, {
    path: '/',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_4__components_public_main__["a" /* default */],
    children: [{
      path: '',
      name: 'index',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'index',
      name: 'index',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_5__components_index__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'product',
      name: 'product',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_6__components_product__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'product/list/:id',
      name: 'product_list',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_7__components_product_list__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'product/list2/:id',
      name: 'product_list2',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_8__components_product_list2__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'product/detail/:id',
      name: 'product_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_9__components_product_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'active/detail',
      name: 'active_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_23__components_active_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our',
      name: 'our',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_10__components_our__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/aboutUs',
      name: 'aboutUs',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_11__components_about_us__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/core',
      name: 'core',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_12__components_core__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/news',
      name: 'news',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_13__components_news__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/news/detail/:id',
      name: 'news_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_14__components_news_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/cases/:id',
      name: 'cases',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_15__components_cases__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/cases/detail/:id',
      name: 'cases_detail',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_16__components_cases_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/brand/:id',
      name: 'brand',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_17__components_brand__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/brand/detail/:id',
      name: 'brand',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_18__components_brand_detail__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'our/contact',
      name: 'contact',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_19__components_contact__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: 'leavemsg',
      name: 'leavemsg',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_20__components_leavemsg__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: '/our/customer_s/:id',
      name: 'customer_s',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_21__components_customer_s__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }, {
      path: '/search/:id',
      name: 'search',
      components: {
        default: __WEBPACK_IMPORTED_MODULE_22__components_search__["a" /* default */],
        head: __WEBPACK_IMPORTED_MODULE_3__components_public_head__["a" /* default */],
        foot: __WEBPACK_IMPORTED_MODULE_2__components_public_foot__["a" /* default */]
      }
    }]
  }]
}));

/***/ }),

/***/ "Yx3D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z2Ou":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Z9Zz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZqLb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foot_vue__ = __webpack_require__("jnKO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b9c3e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_foot_vue__ = __webpack_require__("90+D");
function injectStyle (ssrContext) {
  __webpack_require__("/JQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17b9c3e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b9c3e5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_foot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aAd0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aI2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  watch: {},
  methods: {
    gotop: function gotop() {
      $("html,body").animate({ scrollTop: 0 });
    }
  }

});

/***/ }),

/***/ "aan0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > "+_vm._s(_vm.data.title)+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('div',{staticClass:"cases_detail"},[_c('p',{staticClass:"detail_name"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('p',{staticClass:"detail_time"},[_vm._v("时间："+_vm._s(_vm._f("time")(_vm.data.updatetime)))]),_vm._v(" "),_c('div',{staticClass:"cases_detail_content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bBBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isX: false
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "c1mo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAkCAYAAAA0EkzVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpDRjM5RTk4QkQ3NzcxMUU3QjYyN0Q3NjVBQjkzMDUzNiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpDRjM5RTk4Q0Q3NzcxMUU3QjYyN0Q3NjVBQjkzMDUzNiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkNGMzlFOTg5RDc3NzExRTdCNjI3RDc2NUFCOTMwNTM2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkNGMzlFOThBRDc3NzExRTdCNjI3RDc2NUFCOTMwNTM2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8++/M4WAAAAshJREFUeNrsWj1sEzEUti8Z0w7QIQvqkq1ji1IGkEDqgvibqKjEwoxaygpiQLBSQKywIFWCraRlyYDEAlFBYunWBVEQA2IhnSBn3pf4hUvO95e7S4vOn/SUO9vx+X3vz85FXnn6W2icJ1klOU5SEcVCm2Sb5AHJJhoc3XGP5BXJ6QKSIrTO0L2huRBlknMkt4QFA1y04DE3LRc+rIKYOcuDD3MgZsLy4MOEYzkwwxJjiUmGctyB69fK4kXLFRs7rrH/4owjFuvOwJi7Z0uiVpWh8/5sK3H9ZSewn+ddevYnkWL1Y1KsLJTEo2ZHtL6obInhRTFwzfd4IB7M2P2ujIuPInNhRuZicZDxftcVV084dN3JlhgoNDstxcfPasALfrT/WSCpJfNAlGfC24cBQ9553Rk9lPDlJ5dL3XQ0fbTX9vit23XVOPB6WVAopUWQgsunnP56M/UYEHKkIrWCcsACcFOTNYZzRlahNIrV00DS6VrFdVeEELPPyQ2h5L3OGnGTL7xjvhavyMKoUV5UTvKwmpD9eyTfsDAwWRjfAbxJ29s3SvUI8yBTKHFbqlDChDypyWOi4LVyL0+Z+0wkHvoNHhbNLE9RvmEFq5OSPKagO1+Q4I1HeMzzd263ncv4/4apikwfSqYdKfJAdVJ1q0lQtYkTIuMMHy4OjK2mm46Y4QTME8Jbmjsq8xwTVlmCiOSEG1ZlYMykFTN2ubanawtLjCVmRGJ+WRp8aIOYD5YHH7ZBzJrlwYc1EIPXkvctF32AiwYn39s44ZO8IdkvIBn7WvcLmouBqoSX+mdE7wW3zFGWSZL8uoSxKzmvqaJ1b/R3vkqNZ+M7tCXHX07WRfQ/K3B+X+IFj/N8dVD7GCh6kuRryJhvekyjaBu8TyTz+tPUVw/oK8TOd097xaanbUu37R3kwg7Db4rII5dIHur7GwmTcy74K8AAHOgkQdH5SnYAAAAASUVORK5CYII="

/***/ }),

/***/ "c4Iw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c6RT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__ = __webpack_require__("g3fD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5c1e43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__ = __webpack_require__("uJL9");
function injectStyle (ssrContext) {
  __webpack_require__("HIfF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b5c1e43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5c1e43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c8n2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[(_vm.id==1)?[_c('div',{staticClass:"common_mbx"},[_vm._v("\n      您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > BISAZZA质保说明\n    ")],1),_vm._v(" "),_vm._m(0)]:_vm._e(),_vm._v(" "),(_vm.id==2)?[_c('div',{staticClass:"common_mbx"},[_vm._v("\n      您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 卫浴质保说明\n    ")],1),_vm._v(" "),_vm._m(1)]:_vm._e(),_vm._v(" "),(_vm.id==3)?[_c('div',{staticClass:"common_mbx"},[_vm._v("\n      您当前的位置："),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("首页")]),_vm._v(" >"),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v(" 我们")]),_vm._v(" > 户外SPA质保说明\n    ")],1),_vm._v(" "),_vm._m(2)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_wrap"},[_c('img',{staticClass:"top_banner",attrs:{"src":__webpack_require__("GrOO")}}),_vm._v(" "),_c('div',{staticClass:"about_lists"},[_c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("售")]),_vm._v(" "),_c('span',[_vm._v("售后保障")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_wrap"},[_c('img',{staticClass:"top_banner",attrs:{"src":__webpack_require__("GrOO")}}),_vm._v(" "),_c('div',{staticClass:"about_lists"},[_c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("售")]),_vm._v(" "),_c('span',[_vm._v("售后保障")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_wrap"},[_c('img',{staticClass:"top_banner",attrs:{"src":__webpack_require__("GrOO")}}),_vm._v(" "),_c('div',{staticClass:"about_lists"},[_c('div',{staticClass:"about_item"},[_c('p',{staticClass:"about_title"},[_c('span',{staticClass:"num"},[_vm._v("售")]),_vm._v(" "),_c('span',[_vm._v("售后保障")])]),_vm._v(" "),_c('div',{staticClass:"about_text"},[_vm._v("上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cBVB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_vue__ = __webpack_require__("LHFl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fdc2bd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_vue__ = __webpack_require__("KkIP");
function injectStyle (ssrContext) {
  __webpack_require__("RA+l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9fdc2bd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fdc2bd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cNoL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "chP5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact_code.42feedc.png";

/***/ }),

/***/ "cjQH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1cz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_list_vue__ = __webpack_require__("1bXo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1bf6fc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_list_vue__ = __webpack_require__("B4Mo");
function injectStyle (ssrContext) {
  __webpack_require__("gse5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1bf6fc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1bf6fc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d23r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__ = __webpack_require__("iJEE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caedb366_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__ = __webpack_require__("/6GP");
function injectStyle (ssrContext) {
  __webpack_require__("AJHT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-caedb366"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caedb366_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dAjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("MiD0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40db2c98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("xk08");
function injectStyle (ssrContext) {
  __webpack_require__("VvyA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40db2c98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "deEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      list: [],
      cate: '',
      domain: '',
      parent: []
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getList();
  },
  methods: {
    getparent: function getparent(id) {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid: id
      })).then(function (response) {
        console.log(response);
        _this.parent = response.data.data;
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_product_lists', this.$qs.stringify({
        cid: this.$route.params.id,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this2.list = response.data.data;
        _this2.cate = response.data.cate;
        _this2.getparent(_this2.cate.id);
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "duCw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ewo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_s_vue__ = __webpack_require__("uzG2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653c396c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_s_vue__ = __webpack_require__("c8n2");
function injectStyle (ssrContext) {
  __webpack_require__("gbo2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-653c396c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_s_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653c396c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_s_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g3fD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'head',
	data: function data() {
		return {
			showmenu: false,
			keyword: '',
			showin: false,
			showout: true
		};
	},

	mounted: function mounted() {},
	watch: {},
	methods: {
		showm: function showm() {
			this.showin = !this.showin;
			this.showout = !this.showout;
			this.showmenu = true;
		},
		closem: function closem() {
			this.showmenu = true;
			this.showin = false;
			this.showout = true;
		},

		search: function search() {
			if (!this.keyword) {
				alertMessage('搜索内容不能为空');
				return false;
			}
			this.$router.push('/search/' + this.keyword);
		}
	}

});

/***/ }),

/***/ "gCfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_vue__ = __webpack_require__("3Hk1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c4184ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_vue__ = __webpack_require__("0QWx");
function injectStyle (ssrContext) {
  __webpack_require__("EVG0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c4184ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c4184ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gbo2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gse5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gwNp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hZ2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_detail_vue__ = __webpack_require__("OUWg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90bcdaaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_detail_vue__ = __webpack_require__("ObRd");
function injectStyle (ssrContext) {
  __webpack_require__("5LQc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90bcdaaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90bcdaaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iJEE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'head',
  data: function data() {
    return {
      showmenu: false,
      keyword: ''
    };
  },

  mounted: function mounted() {},
  methods: {
    search: function search() {
      if (!this.keyword) {
        alertMessage('搜索内容不能为空');
        return false;
      }
      this.$router.push('/m/search/' + this.keyword);
    }
  }

});

/***/ }),

/***/ "ihCQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_detail_vue__ = __webpack_require__("9pHH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3824ee97_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_detail_vue__ = __webpack_require__("Hk+z");
function injectStyle (ssrContext) {
  __webpack_require__("imOU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3824ee97"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_news_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3824ee97_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_news_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "imOU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iqsr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core_step.55211b9.png";

/***/ }),

/***/ "jFTN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our aboutUs"},[(_vm.id==1)?[_c('p',{staticClass:"our_common_title"},[_vm._v("BISAZZA质保说明")]),_vm._v(" "),_vm._m(0)]:_vm._e(),_vm._v(" "),(_vm.id==2)?[_c('p',{staticClass:"our_common_title"},[_vm._v("卫浴质保说明")]),_vm._v(" "),_vm._m(1)]:_vm._e(),_vm._v(" "),(_vm.id==3)?[_c('p',{staticClass:"our_common_title"},[_vm._v("户外SPA质保说明")]),_vm._v(" "),_vm._m(2)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_c('div',{staticClass:"aboutUs_item_text"},[_vm._v("\n           上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。\n         ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_c('div',{staticClass:"aboutUs_item_text"},[_vm._v("\n           上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。\n         ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutUs_detail"},[_c('div',{staticClass:"aboutUs_item"},[_c('div',{staticClass:"aboutUs_item_text"},[_vm._v("\n           上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。\n         ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jQr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: [],
      index: '',
      list: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getCategory();
    },
    'index': function index() {
      this.list = [];
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getCategory();
    //this.getList()
    this.index = this.$route.params.id;
  },
  methods: {
    getCategory: function getCategory() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid: 11
      })).then(function (response) {
        //console.log(response);
        _this.data = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
        //this.getList()
      }).catch(function (error) {
        console.log(error);
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_lists', this.$qs.stringify({
        cid: this.index,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this2.list = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "jY4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: [],
      index: '',
      list: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getCategory();
    },
    'index': function index() {
      this.list = [];
      this.getList();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getCategory();
    //this.getList()
    this.index = this.$route.params.id;
  },
  methods: {
    getCategory: function getCategory() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid: 11
      })).then(function (response) {
        //console.log(response);
        _this.data = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
        //this.getList()
      }).catch(function (error) {
        console.log(error);
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_lists', this.$qs.stringify({
        cid: this.index,
        page: 1,
        limit: 1000
      })).then(function (response) {
        console.log(response);
        _this2.list = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "jeEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our detail"},[_c('p',{staticClass:"our_common_title"},[_vm._v("DKING【水龙头】意大利 FIR")]),_vm._v(" "),_c('p',{staticClass:"detail_time"},[_vm._v("2017-01-01")]),_vm._v(" "),_c('div',{staticClass:"detail_content"},[_c('img',{attrs:{"src":"/static/images/m/core.jpg","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jmor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: '',
      cate: '',
      domain: '',
      parent: []
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getDetail();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;

    this.getDetail();
  },
  methods: {
    getparent: function getparent(id) {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid: id
      })).then(function (response) {
        console.log(response);
        _this.parent = response.data.data;
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_product_detail', this.$qs.stringify({
        id: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this2.data = response.data.data;
        _this2.cate = response.data.cate;
        _this2.getparent(_this2.cate.id);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "jnKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'foot',
	data: function data() {
		return {};
	},

	watch: {
		'$route': function $route() {
			this.getconfig();
		}
	},
	mounted: function mounted() {
		this.getconfig();
	},
	methods: {
		gop: function gop() {
			sessionStorage.setItem('id', '1');
			//this.$router.push('/m/product')
			//http://dking.vapps.me/index.php?g=Index&m=Index&a=getconfig&ref='
		},
		getconfig: function getconfig() {
			var _this = this;

			this.$http.get(this.host + '/index.php?g=Index&m=Index&a=getconfig&ref=&ref=' + encodeURIComponent(window.location.href.split('#')[0])).then(function (response) {
				_this.data = response.body.data;
				_this.jssdk = response.body.apilist;
				console.log(response);
				console.log(_this.jssdk);
				__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.config({
					debug: false,
					appId: _this.jssdk.appid, // 和获取Ticke的必须一样------必填，公众号的唯一标识
					timestamp: _this.jssdk.timestamp, // 必填，生成签名的时间戳
					nonceStr: _this.jssdk.noncestr, // 必填，生成签名的随机串
					signature: _this.jssdk.str, // 必填，签名，见附录1
					//需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
					jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
				});
			});
			var that = this;
			__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.ready(function () {
				__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.onMenuShareTimeline({
					title: '帝景国际卫浴', // 分享标题
					//link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					/*link:window.location.href+'?share=true',*/
					imgUrl: this.host + '/static/images/logo.jpg', // 分享图标
					success: function success() {},
					cancel: function cancel() {
						// 用户取消分享后执行的回调函数
					}
				});

				__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.onMenuShareAppMessage({
					title: '帝景国际卫浴', // 分享标题
					desc: '帝景国际卫浴', // 分享描述
					/*link:window.location.href+'?share=true',*/
					//link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: this.host + '/static/images/logo.jpg', // 分享图标
					type: '', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function success() {},
					cancel: function cancel() {
						// 用户取消分享后执行的回调函数
					}
				});
			});
		}
	}

});

/***/ }),

/***/ "k6hN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_main_vue__ = __webpack_require__("4orF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb4c4ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_main_vue__ = __webpack_require__("tAf+");
function injectStyle (ssrContext) {
  __webpack_require__("+7sO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_p_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb4c4ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_p_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kxce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      Category: [],
      hots: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getCategory();
      this.getHot();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getCategory();
    this.getHot();
  },
  methods: {
    getCategory: function getCategory() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        limit: 10,
        cid: 19,
        status: 1
      })).then(function (response) {
        console.log(response);
        _this.Category = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getHot: function getHot() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_hot', this.$qs.stringify({})).then(function (response) {
        console.log(response);
        _this2.hots = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "m/Uf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_detail_vue__ = __webpack_require__("sZXO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f907d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_detail_vue__ = __webpack_require__("6xDk");
function injectStyle (ssrContext) {
  __webpack_require__("jPQS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f907d7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f907d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mTJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_vue__ = __webpack_require__("TMLv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e00af5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_vue__ = __webpack_require__("0I7W");
function injectStyle (ssrContext) {
  __webpack_require__("Xsix")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e00af5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cases_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e00af5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cases_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mgS3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mtP7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our detail"},[_c('p',{staticClass:"our_common_title"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"detail_content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oOp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_us_vue__ = __webpack_require__("WOdY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148f4d48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_us_vue__ = __webpack_require__("TRvh");
function injectStyle (ssrContext) {
  __webpack_require__("c4Iw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-148f4d48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_us_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148f4d48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_us_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oZAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_list2_vue__ = __webpack_require__("deEW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4c7512_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_list2_vue__ = __webpack_require__("SCaA");
function injectStyle (ssrContext) {
  __webpack_require__("2LPQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd4c7512"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_list2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4c7512_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_list2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "prnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leavemsg_vue__ = __webpack_require__("1CF2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45126536_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leavemsg_vue__ = __webpack_require__("AvT3");
function injectStyle (ssrContext) {
  __webpack_require__("HwNh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45126536"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leavemsg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45126536_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_leavemsg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "puUb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isX: false
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "puWL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pyH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"common_mbx"},[_vm._v("\n    您当前的位置：\n    "),_c('router-link',{attrs:{"to":"/index","tag":"span"}},[_vm._v("\n      首页\n    ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/our","tag":"span"}},[_vm._v("\n      > 我们\n    ")]),_vm._v(" "),_vm._l((_vm.parent),function(item,index){return [(index==0)?_c('router-link',{attrs:{"to":"/our/brand/11","tag":"span"}},[_vm._v("\n          > "+_vm._s(item.name)+"\n      ")]):_vm._e(),_vm._v(" "),(index==1)?_c('router-link',{attrs:{"to":"/our/brand/"+item.id,"tag":"span"}},[_vm._v("\n          > "+_vm._s(item.name)+"\n      ")]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('div',{staticClass:"cases_detail"},[_c('p',{staticClass:"detail_name"},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('p',{staticClass:"detail_time"},[_vm._v("时间："+_vm._s(_vm._f("time")(_vm.data.updatetime)))]),_vm._v(" "),_c('div',{staticClass:"cases_detail_content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qAoT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qWnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__ = __webpack_require__("TPYj");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9da77d10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__ = __webpack_require__("jeEy");
function injectStyle (ssrContext) {
  __webpack_require__("IQlt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9da77d10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9da77d10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "r83p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rJ9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our aboutUs",attrs:{"id":"news"}},[_c('p',{staticClass:"our_common_title"},[_vm._v("新闻")]),_vm._v(" "),_c('div',{staticClass:"news_list"},[_vm._l((_vm.news),function(item){return _c('div',{staticClass:"news_item clearfix"},[_c('router-link',{attrs:{"to":"/m/our/news/detail/"+item.id}},[_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"news_text"},[_c('div',{staticClass:"news_text_title"},[_vm._v("\n             "+_vm._s(item.title)+"\n           ")]),_vm._v(" "),_c('p',{staticClass:"news_text_time"},[_vm._v(_vm._s(_vm._f("time")(item.updatetime)))])])])],1)}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.showmore),expression:"showmore"}],staticClass:"more",on:{"click":_vm.more}},[_vm._v("加载更多")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rL5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cremq: false,
      cpcs: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "rQpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foot_vue__ = __webpack_require__("uxAU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efad92e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_foot_vue__ = __webpack_require__("vSdV");
function injectStyle (ssrContext) {
  __webpack_require__("gwNp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0efad92e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efad92e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_foot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rSLk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rcMp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rjyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__("TqGx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ce37d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__("GjZD");
function injectStyle (ssrContext) {
  __webpack_require__("GPRb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ce37d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sV8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_list_vue__ = __webpack_require__("N6DM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e7b231_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_list_vue__ = __webpack_require__("Busw");
function injectStyle (ssrContext) {
  __webpack_require__("duCw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16e7b231"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e7b231_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sZXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: '',
      parent: [],
      domain: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getpic();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getpic();
  },
  methods: {
    getparent: function getparent(id) {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=get_parent', this.$qs.stringify({
        cid: id
      })).then(function (response) {
        console.log(response);
        _this.parent = response.data.data;
        //console.log(this.parent)
        /*this.cate=response.data.cate*/
      }).catch(function (error) {
        console.log(error);
      });
    },
    getpic: function getpic() {
      var _this2 = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=picture', this.$qs.stringify({
        id: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this2.data = response.data.data;
        _this2.getparent(_this2.data.cid);
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "smv8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4ODA4NkMwMUQ4MkQxMUU3QURDOEVCMTdDQjMxRUY2RSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4ODA4NkMwMkQ4MkQxMUU3QURDOEVCMTdDQjMxRUY2RSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjg4MDg2QkZGRDgyRDExRTdBREM4RUIxN0NCMzFFRjZFIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjg4MDg2QzAwRDgyRDExRTdBREM4RUIxN0NCMzFFRjZFIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+MDKKJQAAAJ5JREFUeNrM1mEKgCAMBeBJl+j+p/MSYSYUVnNu5h4JQT/0fZWmCymlSEQr+bcYMlZunMGSf2Ke4JVbYx7gLe+JzQRfORw2A2THt7AvYHOchI2AYv8eZgG7/TSYJkj1QFpMClR/agvGBZvm1IrVgHm1jmBH2/K1WAf9+s1gcwZbjbD/DLaDwPZG2K4PO89gJzWsBoFVV7C6EVYR7wIMAGWBhZs9VeR7AAAAAElFTkSuQmCC"

/***/ }),

/***/ "t17Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__("aI2j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737b2eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__("BbgB");
function injectStyle (ssrContext) {
  __webpack_require__("rcMp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737b2eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tAf+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap container"},[_c('router-view',{attrs:{"name":"head"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('router-view',{attrs:{"name":"foot"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tDWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_core_vue__ = __webpack_require__("Ikjb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36de1000_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_core_vue__ = __webpack_require__("MMer");
function injectStyle (ssrContext) {
  __webpack_require__("aAd0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36de1000"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_core_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36de1000_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_core_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u+Fy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__ = __webpack_require__("kxce");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76127e24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__ = __webpack_require__("KNGw");
function injectStyle (ssrContext) {
  __webpack_require__("Z9Zz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76127e24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76127e24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uJL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head clearfix"},[_c('img',{staticClass:"menu",attrs:{"src":__webpack_require__("Jvgh")},on:{"click":_vm.showm}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/index"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("Z2Ou")}})]),_vm._v(" "),_c('div',{staticClass:"search_wrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],attrs:{"type":"text","name":"","placeholder":"请输入关键字"},domProps:{"value":(_vm.keyword)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value}}}),_vm._v(" "),_c('img',{staticClass:"search_btn",attrs:{"src":__webpack_require__("JEo2")},on:{"click":_vm.search}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showmenu),expression:"showmenu"}],class:{top_menu:true,fadeInLeft:_vm.showin,animated:true,fadeOutLeft:_vm.showout}},[_c('img',{staticClass:"close",attrs:{"src":__webpack_require__("smv8")},on:{"click":_vm.closem}}),_vm._v(" "),_c('div',{staticClass:"menulist"},[_c('router-link',{attrs:{"to":"/index"}},[_c('div',{staticClass:"menu_item",on:{"click":function($event){_vm.showmenu=false}}},[_vm._v("首 页")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/product"}},[_c('div',{staticClass:"menu_item",on:{"click":function($event){_vm.showmenu=false}}},[_vm._v("产 品")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/leavemsg"}},[_c('div',{staticClass:"menu_item",on:{"click":function($event){_vm.showmenu=false}}},[_vm._v("留 言")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/our"}},[_c('div',{staticClass:"menu_item",on:{"click":function($event){_vm.showmenu=false}}},[_vm._v("我 们")])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uxAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'foot',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  methods: {}

});

/***/ }),

/***/ "uzG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      id: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
  }
});

/***/ }),

/***/ "vBKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      data: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.getdetail();
    }
  },
  mounted: function mounted() {
    this.domain = this._routerRoot.domain;
    this.getdetail();
  },
  methods: {
    getdetail: function getdetail() {
      var _this = this;

      this.$axios.post(this.host + '/index.php?g=Index&m=Index&a=picture', this.$qs.stringify({
        id: this.$route.params.id
      })).then(function (response) {
        console.log(response);
        _this.data = response.data.data;
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "vSdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot clearfix"},[_c('div',{staticClass:"foot_menu"},[_c('router-link',{attrs:{"to":"/index"}},[_c('div',{staticClass:"foot_menu_item"},[_vm._v("首 页")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/product"}},[_c('div',{staticClass:"foot_menu_item"},[_vm._v("产 品")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/leavemsg"}},[_c('div',{staticClass:"foot_menu_item"},[_vm._v("留 言")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/our"}},[_c('div',{staticClass:"foot_menu_item"},[_vm._v("我 们")])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"cp"},[_vm._v("上海帝景卫浴设备有限公司 沪ICP备18004570号")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot_address"},[_c('p',[_vm._v("电话( TEL )：021-52366166 52366178 ")]),_vm._v(" "),_c('p',[_vm._v("电子邮件( E-MAIL )："),_c('a',{attrs:{"href":"mailto:wellness@dkingsh.com"}},[_vm._v("wellness@dkingsh.com")])]),_vm._v(" "),_c('p',[_vm._v("地址( ADD )：上海市徐汇区桂箐路7号G7-B201")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vfux":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wf20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cremq: false,
      cpcs: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      domain: 'http://www.dkingsh.com/',
      ismobile: true
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.jump();
      $("html,body").animate({ scrollTop: 0 });
    }
  },
  mounted: function mounted() {
    this.jump();
  },
  methods: {
    jump: function jump() {
      var url = window.location.href;
      //如果是手机端 ，并且地址不是手机端的地址，转换为手机端地址


      if (/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) && url.indexOf('#/m/') < 0) {
        this.ismobile = true;
        if (window.location.href.indexOf('product') > 0) {
          this.$router.push('/m/product');
        } else {
          window.location.href = window.location.href.replace('#/', '#/m/');
        }
      }
      //如果是手机端 ，并且地址是手机端的地址
      if (/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) && url.indexOf('#/m/') > 0) {
        this.ismobile = true;
        return false;
      }

      //如果是非移动端 ，并且地址是手机端的地址
      if (!/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) && url.indexOf('#/m/') > 0) {
        this.ismobile = false;
        //如果是非手机端登录，地址中包含手机地址，跳转到PC端
        if (window.location.href.indexOf('product') > 0) {
          this.$router.push('/product');
        } else {
          window.location.href = window.location.href.replace('#/m/', '#/');
        }
      }
      //如果是非移动端 ，并且地址是非移动端
      if (!/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) && url.indexOf('#/m/') < 0) {
        this.ismobile = false;
        return false;
      }
    }
  }
});

/***/ }),

/***/ "xein":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xk08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index p"},[_c('div',{staticClass:"index_banner"},[_c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.banners),function(item){return _c('div',{staticClass:"swiper-slide"},[(item.link)?_c('a',{attrs:{"href":item.link}},[(item.litpic)?_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}}):_vm._e()]):_vm._e(),_vm._v(" "),(!item.link)?_c('img',{attrs:{"src":_vm.domain+item.litpic,"alt":""}}):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next"})])]),_vm._v(" "),_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title"},[_vm._v("热门品类")]),_vm._v(" "),_c('div',{staticClass:"index_items clearfix"},[_vm._l((_vm.Category),function(item){return [_c('div',{staticClass:"index_item"},[_c('router-link',{attrs:{"to":'/product/list/'+item.id}},[_c('div',[(item.icon1)?_c('img',{attrs:{"src":_vm.domain+item.icon1}}):_vm._e()]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.name))])])],1)]})],2),_vm._v(" "),_c('router-link',{attrs:{"to":"/product"}},[_c('span',{staticClass:"index_more"},[_vm._v("更多")])])],1),_vm._v(" "),_c('div',{staticClass:"index_active"},[_c('p',{staticClass:"common_title"},[_vm._v("精品活动")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/active/detail"}},[(_vm.active.icon1)?_c('img',{attrs:{"src":_vm.domain+_vm.active.icon1}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"hot_wrap"},[_c('div',{staticClass:"common_wrap"},[_c('p',{staticClass:"common_title"},[_vm._v("热门单品")]),_vm._v(" "),_c('div',{staticClass:"hotlist clearfix"},_vm._l((_vm.hots),function(item){return _c('div',{staticClass:"hot_item"},[_c('router-link',{attrs:{"to":"/product/detail/"+item.id}},[_c('div',{staticClass:"hotimg_wrap"},[(item.flag==1)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("c1mo")}}):_vm._e(),_vm._v(" "),(item.flag==2)?_c('img',{staticClass:"tips",attrs:{"src":__webpack_require__("9Nx+")}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"p",attrs:{"src":_vm.domain+item.litpic}})]),_vm._v(" "),_c('p',{staticClass:"p_name"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"p_name_e"},[_vm._v(_vm._s(item.model))])])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xott":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"our aboutUs"},[_c('p',{staticClass:"our_common_title"},[_vm._v("留言")]),_vm._v(" "),_c('div',{staticClass:"leavemsg_from"},[_c('div',{staticClass:"form_item"},[_c('label',{attrs:{"for":"name"}},[_vm._v("姓名：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],attrs:{"type":"text","name":"","id":"name"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form_item"},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("电话：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],attrs:{"type":"text","name":"","id":"mobile"},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form_item"},[_c('label',{attrs:{"for":"email"}},[_vm._v("邮箱：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","name":"","id":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form_item sp"},[_c('label',{attrs:{"for":"t"}},[_vm._v("留言：")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"type":"text","name":"","id":"t"},domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"submit",on:{"click":_vm.submit}},[_vm._v("提 交")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.show),expression:"!show"}],staticClass:"submit"},[_vm._v("提 交")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zRjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_active_detail_vue__ = __webpack_require__("++x8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87dd03c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_active_detail_vue__ = __webpack_require__("mtP7");
function injectStyle (ssrContext) {
  __webpack_require__("xein")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87dd03c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_active_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87dd03c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_active_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTpi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      cremq: false,
      cpcs: true,
      id: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      //this.getconfig()
    }
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
  }
});

/***/ }),

/***/ "zuYS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__ = __webpack_require__("1Lhz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743009ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__ = __webpack_require__("+M8w");
function injectStyle (ssrContext) {
  __webpack_require__("Yx3D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-743009ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743009ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f2a135cc2de9143d131f.js